import React, { useState, useEffect } from 'react';
import axios from 'axios';
import APIEndPoints from '../../../../middleware/APIEndPoints';
import { Outlet, useNavigate } from 'react-router-dom';

const AllProjects = () => {
  const [projectData, setProjectData] = useState({
    title: '',
    category: '',
    description: '',
    githubLink: '',
    image: null,
    imageTitle: '',
    video: null,
    videoTitle: ''
  });

  const [imagePreview, setImagePreview] = useState(null); // State for image preview

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();//for navigation 


  const cloudName = process.env.REACT_APP_CLOUD_NAME;
  const baseURL = APIEndPoints.myprojects.url;



  // Fetch all projects from the backend API
  const fetchProjects = async () => {
    try {
      const response = await axios.get(baseURL); // Make GET request to fetch projects
      setProjects(response.data); // Set projects state with the fetched data
      setLoading(false); // Turn off loading state
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to load projects.');
      setLoading(false); // Turn off loading state even if there's an error
    }
  };


  useEffect(() => {
    fetchProjects();
  }, []);// add projects as dependency to not reload

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProjectData({
      ...projectData,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === 'image' && files.length > 0) {
      const file = files[0];
      setImagePreview(URL.createObjectURL(file)); // Set image preview
    }
    setProjectData({
      ...projectData,
      [name]: files[0]
    });
  };

  const handleUpload = async (type) => {
    const data = new FormData();
    data.append("file", type === 'image' ? projectData.image : projectData.video);
    data.append("upload_preset", type === 'image' ? 'upload' : 'videos_presets');

    try {
      const resourceType = type === 'image' ? 'image' : 'video';
      const api = `https://api.cloudinary.com/v1_1/${cloudName}/${resourceType}/upload`;
      const res = await axios.post(api, data);
      return res.data.secure_url; // Return the secure URL for the uploaded file
    } catch (error) {
      console.error(`Error uploading ${type}:`, error);
      return null; // Return null in case of error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Upload image to Cloudinary
      const imgUrl = await handleUpload('image');
      if (!imgUrl) throw new Error('Image upload failed');

      // Upload video to Cloudinary
      const videoUrl = await handleUpload('video');
      if (!videoUrl) throw new Error('Video upload failed');

      // Create project with image and video data
      const projectPayload = {
        title: projectData.title,
        category: projectData.category,
        description: projectData.description,
        githubLink: projectData.githubLink,
        imageSlider: [{ title: projectData.imageTitle, url: imgUrl }],
        videoOfProjects: [{ title: projectData.videoTitle, url: videoUrl }]
      };

      await axios.post(baseURL, projectPayload);

      alert('Project created successfully!');
      setProjectData({
        title: '',
        category: '',
        description: '',
        githubLink: '',
        image: null,
        imageTitle: '',
        video: null,
        videoTitle: ''
      });
      setImagePreview(null); // Clear image preview after submission

      console.log("Successfuly created project")
    } catch (error) {
      console.error('Error creating project:', error);
      alert('Failed to create project.');
    }
  };

  // Delete a project
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this project?");
    if (confirmDelete) {
      try {
        await axios.delete(`${baseURL}/${id}`);
        alert('Project deleted successfully.');
        fetchProjects(); // Fetch the updated list of projects after deletion
      } catch (error) {
        console.error('Error deleting project:', error);
        alert('Failed to delete project.');
      }
    }
  };

  const handleEditClick = (projectId) => {
    // Redirect to the edit page for the selected project
    navigate(`/admin-abhijan-home/projects/${projectId}`);
  };

  return (
    <div className="bg-[#1d0c39] min-h-screen p-6 text-white">
      <h1 className="text-2xl font-bold mb-6">Create New Project</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="title">Project Title:</label>
          <input
            type="text"
            id="title"
            name="title"
            value={projectData.title}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="category">Project Category:</label>
          <input
            type="text"
            id="category"
            name="category"
            value={projectData.category}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="description">Project Description:</label>
          <textarea
            id="description"
            name="description"
            value={projectData.description}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="githubLink">GitHub Link:</label>
          <input
            type="url"
            id="githubLink"
            name="githubLink"
            value={projectData.githubLink}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <div>
          <label htmlFor="image">Upload Image:</label>
          <input
            type="file"
            id="image"
            name="image"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
          <label htmlFor="imageTitle" className="block mt-2">Image Title:</label>
          <input
            type="text"
            id="imageTitle"
            name="imageTitle"
            value={projectData.imageTitle}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />

          {/* Image Preview */}
          {imagePreview && (
            <div className="mt-4">
              <h3 className="text-lg">Image Preview:</h3>
              <img src={imagePreview} alt="Preview" className="mt-2 w-full h-auto rounded" />
            </div>
          )}
        </div>

        <div>
          <label htmlFor="video">Upload Video:</label>
          <input
            type="file"
            id="video"
            name="video"
            accept="video/*"
            onChange={handleFileChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
          <label htmlFor="videoTitle" className="block mt-2">Video Title:</label>
          <input
            type="text"
            id="videoTitle"
            name="videoTitle"
            value={projectData.videoTitle}
            onChange={handleInputChange}
            className="w-full p-2 mt-2 rounded bg-gray-800 text-white"
            required
          />
        </div>

        <button type="submit" className="bg-blue-600 p-2 rounded w-full mt-6 hover:bg-blue-700">
          Create Project
        </button>
      </form>


      <h1 className="text-2xl font-bold mb-6">All Projects</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.length > 0 ? (
          projects.map((project) => (
            <div key={project._id} className="bg-gray-800 p-4 rounded-lg">
              <h2 className="text-xl font-bold mb-2">{project.title}</h2>
              <p className="mb-2">{project.description}</p>
              <p className="text-sm text-gray-400 mb-2">Category: {project.category}</p>
              <a
                href={project.githubLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:underline"
              >
                GitHub Link
              </a>

              {/* Display image slider */}
              {project.imageSlider.length > 0 && (
                <div className="mt-4">
                  <h3 className="text-lg">Images:</h3>
                  {project.imageSlider.map((image) => (
                    <div key={image._id} className="mt-2">
                      <img
                        src={image.url}
                        alt={image.title}
                        className="w-full h-auto rounded"
                      />
                      <p className="text-sm text-gray-400">{image.title}</p>
                    </div>
                  ))}
                </div>
              )}

              {/* Display video section */}
              {project.videoOfProjects.length > 0 && (
                <div className="mt-4">
                  <h3 className="text-lg">Video:</h3>
                  {project.videoOfProjects.map((video) => (
                    <div key={video._id} className="mt-2">
                      <video
                        src={video.url}
                        controls
                        className="w-full h-auto rounded"
                      />
                      <p className="text-sm text-gray-400">{video.title}</p>
                    </div>
                  ))}
                </div>
              )}
              {/* Edit and Delete Buttons */}
              <div className="mt-4 flex justify-between">
                <button
                  onClick={() => handleEditClick(project._id)}

                  className="bg-green-500 px-4 py-2 rounded text-white hover:bg-green-600"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(project._id)}
                  className="bg-red-500 px-4 py-2 rounded text-white hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>No projects found.</p>
        )}
      </div>
    </div>
  );
};

export default AllProjects;
